import { render, staticRenderFns } from "./businessSubpage.vue?vue&type=template&id=0dd44474&"
import script from "./businessSubpage.vue?vue&type=script&lang=js&"
export * from "./businessSubpage.vue?vue&type=script&lang=js&"
import style0 from "./businessSubpage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports